(function () {
  // Function to style Klaro before it becomes visible
  function styleKlaro() {
    const klaro = document.getElementById('klaro');
    if (!klaro) return;

    // Apply styles to the cookie notice container
    const cookieNotice = document.querySelector('#klaro .cookie-notice');
    if (cookieNotice) {
      // Container positioning and dimensions
      cookieNotice.style.position = 'fixed';
      cookieNotice.style.bottom = '0';
      cookieNotice.style.top = 'auto';
      cookieNotice.style.left = '0';
      cookieNotice.style.right = '0';
      cookieNotice.style.width = '100%';
      cookieNotice.style.maxWidth = '100%';
      cookieNotice.style.background = '#333';
      cookieNotice.style.color = '#fff';
      cookieNotice.style.padding = '20px';
      cookieNotice.style.textAlign = 'center';
      cookieNotice.style.zIndex = '9999';
      cookieNotice.style.display = 'flex';
      cookieNotice.style.alignItems = 'center';
      cookieNotice.style.justifyContent = 'center';
      cookieNotice.style.margin = '0';
      cookieNotice.style.boxSizing = 'border-box';
      cookieNotice.style.borderRadius = '0';
      cookieNotice.style.border = 'none';

      // Style the body content section
      const cnBody = document.querySelector('#klaro .cookie-notice .cn-body');
      if (cnBody) {
        cnBody.style.display = 'flex';
        cnBody.style.alignItems = 'center';
        cnBody.style.gap = '15px';
        cnBody.style.flexWrap = 'wrap';
        cnBody.style.justifyContent = 'center';
        cnBody.style.width = '100%';
        cnBody.style.maxWidth = '1200px';
        cnBody.style.margin = '0 auto';
        cnBody.style.padding = '0';
      }

      // Hide the title if present
      const title = document.querySelector('#klaro #id-cookie-title');
      if (title) {
        title.style.display = 'none';
      }

      // Style the cookie notice text
      const notice = document.querySelector('#klaro #id-cookie-notice');
      if (notice) {
        notice.style.margin = '0';
        notice.style.padding = '0';
        notice.style.flexGrow = '1';
        notice.style.textAlign = 'center';
        notice.style.color = '#ffffff'; // Make the text white

        // Also target the strong element within the notice
        const strongElement = notice.querySelector('strong');
        if (strongElement) {
          strongElement.style.color = '#ffffff'; // Make the strong text white too
        }
      }

      // Style the button container
      const cnOk = document.querySelector('#klaro .cookie-notice .cn-ok');
      if (cnOk) {
        cnOk.style.display = 'flex';
        cnOk.style.alignItems = 'center';
        cnOk.style.margin = '0';
        cnOk.style.gap = '15px';
        cnOk.style.justifyContent = 'center'; // Center the buttons
      }

      // Style the accept button
      const acceptButton = document.querySelector('#klaro .cookie-notice .cm-btn.cm-btn-success');
      if (acceptButton) {
        acceptButton.style.background = '#0078d4';
        acceptButton.style.color = '#fff';
        acceptButton.style.border = 'none';
        acceptButton.style.padding = '12px';
        acceptButton.style.cursor = 'pointer';
        acceptButton.style.textTransform = 'uppercase';
        acceptButton.style.fontWeight = 'bold';
        acceptButton.style.borderRadius = '0';
        acceptButton.style.margin = '0 5px';
        acceptButton.style.lineHeight = '1.5';
      }

      // Style the customize/learn more link as a button with yellow background and black text
      const customizeLink = document.querySelector('#klaro .cookie-notice .cm-link.cn-learn-more');
      if (customizeLink) {
        // First check if we've already moved the customize link into the button container
        const buttonsContainer = document.querySelector('#klaro .cookie-notice .cn-buttons');
        const existingCustomizeInButtons = buttonsContainer ?
          buttonsContainer.querySelector('.cm-link.cn-learn-more') : null;

        if (!existingCustomizeInButtons && buttonsContainer) {
          // Style the link as a button
          customizeLink.style.background = '#ffcc00';     // Yellow background
          customizeLink.style.color = '#000';             // Black text
          customizeLink.style.border = 'none';
          customizeLink.style.padding = '12px';
          customizeLink.style.cursor = 'pointer';
          customizeLink.style.textTransform = 'uppercase';
          customizeLink.style.fontWeight = 'bold';
          customizeLink.style.borderRadius = '0';
          customizeLink.style.margin = '0 5px';
          customizeLink.style.textDecoration = 'none';    // Remove underline
          customizeLink.style.display = 'inline-flex';    // Use inline-flex for better alignment
          customizeLink.style.alignItems = 'center';      // Center text vertically
          customizeLink.style.justifyContent = 'center';  // Center text horizontally
          customizeLink.style.lineHeight = '1.5';         // Match line height with other buttons
          customizeLink.style.height = '100%';            // Match height with other buttons

          // Move the customize link into the buttons container to align properly
          buttonsContainer.insertBefore(customizeLink, buttonsContainer.firstChild);
        } else if (existingCustomizeInButtons) {
          // If it's already in the buttons container, just style it
          existingCustomizeInButtons.style.background = '#ffcc00';
          existingCustomizeInButtons.style.color = '#000';
          existingCustomizeInButtons.style.border = 'none';
          existingCustomizeInButtons.style.padding = '12px';
          existingCustomizeInButtons.style.cursor = 'pointer';
          existingCustomizeInButtons.style.textTransform = 'uppercase';
          existingCustomizeInButtons.style.fontWeight = 'bold';
          existingCustomizeInButtons.style.borderRadius = '0';
          existingCustomizeInButtons.style.margin = '0 5px';
          existingCustomizeInButtons.style.textDecoration = 'none';
          existingCustomizeInButtons.style.display = 'inline-flex';
          existingCustomizeInButtons.style.alignItems = 'center';
          existingCustomizeInButtons.style.justifyContent = 'center';
          existingCustomizeInButtons.style.lineHeight = '1.5';
          existingCustomizeInButtons.style.height = '100%';

          // Hide the original if there are two
          if (customizeLink !== existingCustomizeInButtons) {
            customizeLink.style.display = 'none';
          }
        }
      }

      // Style the decline button - with white border
      const declineButton = document.querySelector('#klaro .cookie-notice .cm-btn.cm-btn-danger.cn-decline');
      if (declineButton) {
        declineButton.style.background = '#333'; // Match the banner background
        declineButton.style.color = '#fff';     // White text
        declineButton.style.border = '1px solid #fff'; // White border added back
        declineButton.style.padding = '12px';
        declineButton.style.cursor = 'pointer';
        declineButton.style.textTransform = 'uppercase';
        declineButton.style.fontWeight = 'bold';
        declineButton.style.borderRadius = '0';
        declineButton.style.margin = '0 5px';
        declineButton.style.lineHeight = '1.5';
      }

      // Style the close button (X) - keep it minimal and borderless
      const closeButton = document.querySelector('#klaro .cookie-notice .cn-decline.klaro-close');
      if (closeButton) {
        closeButton.style.background = 'transparent'; // Transparent background
        closeButton.style.color = '#fff';            // White text
        closeButton.style.border = 'none';           // No border
        closeButton.style.padding = '12px';
        closeButton.style.cursor = 'pointer';
        closeButton.style.fontWeight = 'bold';
        closeButton.style.fontSize = '18px';         // Larger font size for X
        closeButton.style.margin = '0 5px';
        closeButton.style.opacity = '0.8';           // Slightly transparent
      }

      // Style the button container
      const buttons = document.querySelector('#klaro .cookie-notice .cn-buttons');
      if (buttons) {
        buttons.style.display = 'inline-flex';
        buttons.style.flexWrap = 'nowrap';
        buttons.style.justifyContent = 'center';
        buttons.style.alignItems = 'center'; // Ensure vertical alignment of all buttons
      }

      // Make Klaro visible after styling
      klaro.style.visibility = 'visible';
    }
  }

  // Function to handle hiding the Klaro banner when user interacts with it
  function setupKlaroEventListeners() {
    // Get the accept button
    const acceptButton = document.querySelector('#klaro .cookie-notice .cm-btn.cm-btn-success');
    if (acceptButton) {
      acceptButton.addEventListener('click', function() {
        const klaro = document.getElementById('klaro');
        if (klaro) {
          klaro.style.display = 'none';
        }
      });
    }

    // Handle the X close button
    const closeButton = document.querySelector('#klaro .cookie-notice .cn-decline.klaro-close');
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        const klaro = document.getElementById('klaro');
        if (klaro) {
          klaro.style.display = 'none';
        }
      });
    }

    // Handle the decline button too
    const declineButton = document.querySelector('#klaro .cookie-notice .cm-btn.cm-btn-danger.cn-decline');
    if (declineButton) {
      declineButton.addEventListener('click', function() {
        const klaro = document.getElementById('klaro');
        if (klaro) {
          klaro.style.display = 'none';
        }
      });
    }
  }

  // Add initial CSS to prevent flash of unstyled content
  const style = document.createElement('style');
  style.textContent = '#klaro { visibility: hidden; }';
  document.head.appendChild(style);

  // Function to set up an observer that will run once and then disconnect
  function createObserver() {
    return new MutationObserver((mutations, obs) => {
      const klaro = document.getElementById('klaro');
      if (klaro) {
        obs.disconnect();
        styleKlaro();
        setupKlaroEventListeners(); // Add event listeners after styling
      }
    });
  }

  // Set up observer
  const observer = createObserver();
  observer.observe(document.body, { childList: true, subtree: true });

  // Also try immediately in case Klaro is already present
  styleKlaro();
  setupKlaroEventListeners(); // Try to set up event listeners immediately too

  // Add resize handler to ensure styles are maintained when window is resized
  window.addEventListener('resize', styleKlaro);
})();
